<template>
  <div class="page">
    <div class="group_1">
      <div class="box_1">
        <van-form @submit="onSubmit">
          <div class="title"><span>发票类型</span><span class="text_1">电子普通发票</span></div>
          <van-field
            v-model="invoiceHeader"
            name="抬头名称"
            label="抬头名称"
            placeholder="请输入抬头名称"
            error-message-align="right"
            input-align="right"
          />
          <van-field
            v-model="identifyNum"
            name="单位税号"
            label="单位税号"
            placeholder="请输入单位税号"
            input-align="right"
            error-message-align="right"
          />
          <div style="margin: 24px; display: flex; align-items: center; justify-content: center">
            <van-button round block type="info" native-type="submit">确定</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toGenerateInvoice } from '../../api/myInvoice';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      invoiceHeader: '',
      identifyNum: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    onSubmit(values) {
      console.log('submit', values);
      if (!this.invoiceHeader || this.invoiceHeader.trim() === '') {
        this.$utils.showToast('请输入抬头名称！');
        return;
      }
      if (!this.identifyNum || this.identifyNum.trim() === '') {
        this.$utils.showToast('请输入单位税号！');
        return;
      }
      if (this.identifyNum.length < 15 || this.identifyNum.length > 20) {
        this.$utils.showToast('请输入正确的单位税号！');
        return;
      }
      const data = {
        orderId: this.$route.query.id,
        invoiceHeader: this.invoiceHeader,
        identifyNum: this.identifyNum
      };
      toGenerateInvoice(data).then(res => {
        if (res.data.code == '200') {
          this.$utils.showToast(res.data.msg);
          setTimeout(() => {
            this.$router.push({
              path: '/myInvoice'
            });
          }, 1000);
        } else {
          this.$utils.showToast(res.data.msg);
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
}
.group_1 {
  padding: 10px 15px;
}
.box_1 {
  // width: 345px;
  height: 167px;
  padding: 17px 15px;

  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
}
.title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid#f5f6f7;
  font-size: 14px;
  color: #646566;
  height: 40px;
  .text_1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #2a70f2;
  }
}
::v-deep {
  .van-button {
    width: 186px;
    height: 46px;
    background: #2a70f2;
    border-radius: 23px 23px 23px 23px;
  }
}
::v-deep {
  .van-cell-group--inset {
    margin: 0;
    border-top: 0;
  }
  .van-cell-group--inset::after {
    border: 0;
  }
  .van-cell {
    padding: 0;
    display: flex;
    align-items: center;
    height: 56px;
  }
  .van-cell::after {
    border-bottom: 1px solid #ebedf0;
    // width: 315px;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .van-icon {
    color: #969799;
  }
}
</style>
